/** @file RENDER_CORE_ERRORS: the error codes render-core throws (plan R1). */

/** Codes thrown by `place`: the output list is too short, a pick names an unknown sheet, an anchor an unknown node. */
export const RENDER_CORE_ERRORS = {
  IMPOSTOR_LIST_TOO_SMALL: 'IMPOSTOR_LIST_TOO_SMALL', SHEET_UNKNOWN: 'SHEET_UNKNOWN', NODE_UNKNOWN: 'NODE_UNKNOWN',
} as const;
